<template>
  <div>
    <div v-if="!this.loading">
      <base-header type="info" class="pb-6">
        <div class="row align-items-center py-4">
          <div class="col-lg-6 col-7">
            <h6 class="h2 text-white d-inline-block mb-0">{{this.$store.getters.getUser}}
              Dashboard</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </div>
          <!--          <div class="col-lg-6 col-5 text-right">-->
          <!--            <base-button size="sm" type="neutral">New</base-button>-->
          <!--            <base-button size="sm" type="neutral">Filters</base-button>-->
          <!--          </div>-->
        </div>
        <div class="row">
          <div class="col-xl-2 col-lg-2 col-md-3">
            <stats-card title="Total Number Requests"
                        type="gradient-red"
                        :sub-title=this.statsSumActionsLinkedin.SumNbrConnections.toString()
                        icon="fa fa-plug">

              <template v-if="printPercentage()" slot="footer">

                <div
                  v-if="this.statsDiffActionsLinkedin.DiffSumNbrConnections.toString().includes('-')">
                  <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i>{{this.statsDiffActionsLinkedin.DiffSumNbrConnections.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
                <div v-else>
                  <span class="text-success mr-2"><i class="fa fa-arrow-up"></i>{{this.statsDiffActionsLinkedin.DiffSumNbrConnections.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
              </template>
            </stats-card>
          </div>
          <div class="col-xl-2 col-lg-2 col-md-3">

            <stats-card title="Total Number Messages"
                        type="gradient-orange"
                        :sub-title=this.statsSumActionsLinkedin.SumNbrMessages.toString()
                        icon="fa fa-comments">

              <template v-if="printPercentage()" slot="footer">
                <div
                  v-if="this.statsDiffActionsLinkedin.DiffSumNbrMessages.toString().includes('-')">
                  <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i>{{this.statsDiffActionsLinkedin.DiffSumNbrMessages.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
                <div v-else>
                  <span class="text-success mr-2"><i class="fa fa-arrow-up"></i>{{this.statsDiffActionsLinkedin.DiffSumNbrMessages.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
              </template>
            </stats-card>
          </div>
          <div class="col-xl-2 col-lg-2 col-md-2">
            <stats-card title="Total Users Withdrawn"
                        type="gradient-green"
                        :sub-title=this.statsSumActionsLinkedin.SumWithdraw.toString()
                        icon="fa fa-eraser">

              <template v-if="printPercentage()" slot="footer">
                <div
                  v-if="this.statsDiffActionsLinkedin.DiffSumWithdraw.toString().includes('-')">
                  <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i>{{this.statsDiffActionsLinkedin.DiffSumWithdraw.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
                <div v-else>
                  <span class="text-success mr-2"><i class="fa fa-arrow-up"></i>{{this.statsDiffActionsLinkedin.DiffSumWithdraw.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
              </template>
            </stats-card>

          </div>
          <div class="col-xl-2 col-lg-2 col-md-2">
            <stats-card title="Total liked posts"
                        type="gradient-info"
                        :sub-title=this.statsSumActionsLinkedin.SumLikedPosts.toString()
                        icon="fa fa-heart">

              <template v-if="printPercentage()" slot="footer">
                <div
                  v-if="this.statsDiffActionsLinkedin.DiffSumLikedPosts.toString().includes('-')">
                  <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i>{{this.statsDiffActionsLinkedin.DiffSumLikedPosts.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
                <div v-else>
                  <span class="text-success mr-2"><i class="fa fa-arrow-up"></i>{{this.statsDiffActionsLinkedin.DiffSumLikedPosts.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
              </template>
            </stats-card>
          </div>
          <div class="col-xl-2 col-lg-2 col-md-2">
            <stats-card title="Total Endorses"
                        type="gradient-info"
                        :sub-title=this.statsSumActionsLinkedin.SumNbrEndorse.toString()
                        icon="fa fa-handshake">

              <template v-if="printPercentage()" slot="footer">
                <div
                  v-if="this.statsDiffActionsLinkedin.DiffSumNbrEndorse.toString().includes('-')">
                  <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i>{{this.statsDiffActionsLinkedin.DiffSumNbrEndorse.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
                <div v-else>
                  <span class="text-success mr-2"><i class="fa fa-arrow-up"></i>{{this.statsDiffActionsLinkedin.DiffSumNbrEndorse.toString()}}%</span>
                  <span class="text-nowrap">Since last month</span>
                </div>
              </template>
            </stats-card>
          </div>
        </div>
      </base-header>

      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col-12" v-if="linkednLikedPostsState">
            <card>
              <div slot="header" class="row align-items-center">
                <div class="col">
                  <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
                  <h5 class="h3 mb-0">Posts that we liked for you:</h5>
                </div>
              </div>
              <line-chart
                :height="350"
                ref="bigChart"
                :chart-data="lineLikedPosts.chartData"
                :extra-options="lineLikedPosts.extraOptions"
              >
              </line-chart>

            </card>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <card>
              <template slot="header">
                <!-- Subtitle -->
                <h6 class="surtitle">Location</h6>
                <!-- Title -->
                <h5 class="h3 mb-0">Top {{this.pieOptionsMetricsLocation.chartData.labels.length}}
                  location in
                  your LinkedIn account last time analysis
                  : {{this.refreshTimerWithdraw}}</h5>
              </template>
              <div class="chart">
                <pie-chart
                  id="pie-chart"
                  :height="350"
                  :chart-data="pieOptionsMetricsLocation.chartData"
                  :extra-options="pieOptionsMetricsLocation.extraOptions"
                >
                </pie-chart>
              </div>
            </card>
          </div>
          <div class="col-4">
            <card>
              <template slot="header">
                <!-- Subtitle -->
                <h6 class="surtitle">Industry</h6>
                <!-- Title -->
                <h5 class="h3 mb-0">Top {{this.pieOptionsMetricsIndustry.chartData.labels.length}}
                  Industry in
                  your LinkedIn account last time analysis
                  : {{this.refreshTimerWithdraw}}</h5>
              </template>
              <div class="chart">
                <pie-chart
                  id="pie-chart2"
                  :height="350"
                  :chart-data="pieOptionsMetricsIndustry.chartData"
                  :extra-options="pieOptionsMetricsIndustry.extraOptions"
                >
                </pie-chart>
              </div>
            </card>
          </div>
          <div class="col-4">
            <card>
              <template slot="header">
                <!-- Subtitle -->
                <h6 class="surtitle">Overview</h6>
                <!-- Title -->
                <h5 class="h3 mb-0">Distribution of pending invitations in your LinkedIn account
                  last time analysis
                  : {{this.refreshTimerWithdraw}}</h5>
              </template>

              <div class="chart-area">
                <div v-if="barChartPendingRequest.chartData.datasets[0].data.length === 0">
                  <h5 style="color:green"> You have no pending requests that are more than one
                    week</h5>
                </div>
                <bar-chart
                  :height="350"
                  :chart-data="barChartPendingRequest.chartData"
                  :extra-options="barChartPendingRequest.extraOptions"
                >
                </bar-chart>
              </div>
            </card>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <card>
              <template slot="header">
                <!-- Subtitle -->
                <h6 class="surtitle">Overview</h6>
                <!-- Title -->
                <h5 class="h3 mb-0">Accepted Users</h5>
              </template>
              <div class="chart-area">
                <bar-chart
                  :height="300"
                  :chart-data="barChartAcceptedUsers.chartData"
                  :extra-options="barChartAcceptedUsers.extraOptions"
                >
                </bar-chart>
              </div>
            </card>
          </div>

        </div>
      </div>
    </div>
    <loading-screen :is-loading="this.isSplashloading"></loading-screen>

  </div>
</template>
<script>
    // Components
    import BaseProgress from '../components/Argon/BaseProgress';
    import RouteBreadCrumb from '../components/Argon/Breadcrumb/RouteBreadcrumb';
    import StatsCard from '../components/Argon/Cards/StatsCard';

    import DoughnutChart from '../components/Argon/Charts/DoughnutChart';
    import LineChart from '../components/Argon/Charts/LineChart';
    import BarChart from '../components/Argon/Charts/BarChart';
    import PieChart from '../components/Argon/Charts/PieChart';
    import * as chartConfigs from '../components/Argon/Charts/config';
    import labels from "chartjs-plugin-labels";

    import BaseHeader from '../components/Argon/BaseHeader';
    import {refreshIdToken} from '../util/utilsYsy'

    import {Charts} from "../components/Argon/Charts/config";
    import Loader from "./Loader";

    import zoom from 'chartjs-plugin-zoom';

    function randomScalingFactor() {
        return Math.round(Math.random() * 100);
    }

    export default {
        name: 'DashboardUser',
        components: {
            BaseProgress,
            DoughnutChart,
            LineChart,
            BarChart,
            PieChart,
            StatsCard,
            BaseHeader,
            RouteBreadCrumb,
            'loading-screen': Loader
        },
        data() {
            return {
                linkednLikedPostsState: false,
                loading: true,
                isSplashloading: false,
                statisticConnection: false,
                metricsUser: false,
                refreshTimerWithdraw: '',
                colorsForPie: ['#008ffb', '#00e396', '#feb019', '#ff4560', '#775dd0'],
                pieOptionsMetricsLocation: {
                    chartData: {
                        labels: [],
                        datasets: [{
                            data: [],
                            backgroundColor: [],
                            label: 'Location metrics'
                        }],
                    },
                    extraOptions: {
                        plugins: {
                            labels: {
                                precision: 0,
                                // identifies whether or not labels of value 0 are displayed, default is false
                                showZero: true,
                                fontSize: 18,
                                overlap: false,
                                // font color, can be color array for each data or function for dynamic color, default is defaultFontColor
                                fontColor: '#fff',
                            }
                        },
                        responsive: true,
                        legend: {

                            display: true,
                            position: 'top',
                        },
                        animation: {
                            animateScale: true,
                            animateRotate: true
                        }
                    }
                },
                pieOptionsMetricsIndustry: {
                    chartData: {
                        labels: [],
                        datasets: [{
                            data: [],
                            backgroundColor: [],
                            label: 'Industry metrics'
                        }],
                    },
                    extraOptions: {
                        plugins: {
                            labels: {
                                precision: 0,
                                // identifies whether or not labels of value 0 are displayed, default is false
                                showZero: true,
                                fontSize: 18,
                                overlap: false,
                                // font color, can be color array for each data or function for dynamic color, default is defaultFontColor
                                fontColor: '#fff',
                            }
                        },
                        responsive: true,
                        legend: {

                            display: true,
                            position: 'top',
                        },
                        animation: {
                            animateScale: true,
                            animateRotate: true
                        }
                    }
                },
                barChartAcceptedUsers: {
                    chartData: {
                        labels: [],

                        datasets: [{
                            label: 'Accepted request',
                            backgroundColor: '#008ffb',
                            data: []

                        }, {
                            label: 'Accepted from message 1',
                            backgroundColor: '#00e396',
                            data: []
                        }, {
                            label: 'Accepted from message 2',
                            backgroundColor: '#feb019',
                            data: []
                        }, {
                            label: 'Request sent',
                            backgroundColor: '#ff4560',
                            data: []
                        }],

                    },
                    extraOptions: {
                        plugins: {
                            zoom: {
                                // // Container for pan options
                                pan: {
                                    // drag: {
                                    //     borderColor: 'rgba(225,225,225,0.3)',
                                    //     borderWidth: 5,
                                    //     backgroundColor: 'rgb(225,225,225)',
                                    //     animationDuration: 0
                                    // },
                                    enabled: true,
                                    mode: 'x',
                                    speed: 20,

                                    // Function called while the user is panning
                                    onPan: function ({chart}) {
                                        console.log(`I'm panning!!!`);
                                    },
                                    // Function called once panning is completed
                                    onPanComplete: function ({chart}) {
                                        console.log(`I was panned!!!`);
                                    }
                                },

                                // Container for zoom options
                                zoom: {
                                    // drag: {
                                    //     borderColor: 'rgba(225,225,225,0.3)',
                                    //     borderWidth: 5,
                                    //     backgroundColor: 'rgb(225,225,225)',
                                    //     animationDuration: 0
                                    // },
                                    enabled: false,
                                    mode: 'x',
                                    speed: 0.05,
                                    // Function called while the user is zooming
                                    onZoom: function ({chart}) {
                                        console.log(`I'm zooming!!!`);
                                    },
                                    // Function called once zooming is completed
                                    onZoomComplete: function ({chart}) {
                                        console.log(`I was zoomed!!!`);
                                    }
                                }
                            },
                            labels: {
                                render: 'value',
                                // identifies whether or not labels of value 0 are displayed, default is false
                                // showZero: true,
                                fontSize: 0,

                                // font color, can be color array for each data or function for dynamic color, default is defaultFontColor
                                fontColor: 'black',
                                labelOffset: 20,
                            }
                        },

                        tooltips: {
                            mode: 'index',
                            // intersect: false
                        },
                        responsive: true,
                        legend: {

                            display: true,
                            position: 'top',
                        },
                        scales: {
                            xAxes: [{
                                barThickness: 20,  // number (pixels) or 'flex'
                                maxBarThickness: 20, // number (pixels)
                                stacked: true,
                            }],
                            yAxes: [{
                                stacked: true
                            }]
                        }
                    }
                },
                barChartPendingRequest:
                    {
                        chartData: {
                            labels: [],

                            datasets:
                                [{
                                    label: 'Pending request',
                                    backgroundColor: '#008ffb',
                                    data: []

                                }],

                        }
                        ,
                        extraOptions: {
                            plugins: {
                                labels: {
                                    render: 'value',
                                    // identifies whether or not labels of value 0 are displayed, default is false
                                    // showZero: true,
                                    fontSize:
                                        12,

                                    // font color, can be color array for each data or function for dynamic color, default is defaultFontColor
                                    fontColor:
                                        'black',
                                    labelOffset:
                                        20,
                                }
                            }
                            ,

                            tooltips: {
                                mode: 'index',
                                // intersect: false
                            }
                            ,
                            responsive: true,
                            legend:
                                {

                                    display: true,
                                    position:
                                        'top',
                                }
                            ,
                            scales: {
                                xAxes: [{
                                    barThickness: 20,  // number (pixels) or 'flex'
                                    maxBarThickness: 20, // number (pixels)
                                    stacked: true,
                                }],
                                yAxes:
                                    [{
                                        stacked: true
                                    }]
                            }
                        }
                    }
                ,
                lineLikedPosts: {
                    chartData: {
                        labels: [],
                        datasets:
                            [{
                                label: 'Liked posts',
                                data: [],
                            }],
                    }
                    ,
                    extraOptions: {
                        responsive: true
                    }
                    ,
                }
                ,
                statsSumActionsLinkedin: '',
                statsDiffActionsLinkedin:
                    '',

            }
        }
        ,
        methods:
            {
                printPercentage() {
                    const today = new Date();
                    const day = today.getDate();
                    return day > 25;
                }
                ,
                getAllUrlParams(url) {

                    // get query string from url (optional) or window
                    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

                    // we'll store the parameters here
                    var obj = {};

                    // if query string exists
                    if (queryString) {

                        // stuff after # is not part of query string, so get rid of it
                        queryString = queryString.split('#')[0];

                        // split our query string into its component parts
                        var arr = queryString.split('&');

                        for (var i = 0; i < arr.length; i++) {
                            // separate the keys and the values
                            var a = arr[i].split('=');

                            // set parameter name and value (use 'true' if empty)
                            var paramName = a[0];
                            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                            // (optional) keep case consistent
                            paramName = paramName.toLowerCase();
                            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                            if (paramName.match(/\[(\d+)?\]$/)) {

                                // create key if it doesn't exist
                                var key = paramName.replace(/\[(\d+)?\]/, '');
                                if (!obj[key]) obj[key] = [];

                                // if it's an indexed array e.g. colors[2]
                                if (paramName.match(/\[\d+\]$/)) {
                                    // get the index value and add the entry at the appropriate position
                                    var index = /\[(\d+)\]/.exec(paramName)[1];
                                    obj[key][index] = paramValue;
                                } else {
                                    // otherwise add the value to the end of the array
                                    obj[key].push(paramValue);
                                }
                            } else {
                                // we're dealing with a string
                                if (!obj[paramName]) {
                                    // if it doesn't exist, create property
                                    obj[paramName] = paramValue;
                                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                                    // if property does exist and it's a string, convert it to an array
                                    obj[paramName] = [obj[paramName]];
                                    obj[paramName].push(paramValue);
                                } else {
                                    // otherwise add the property
                                    obj[paramName].push(paramValue);
                                }
                            }
                        }
                    }

                    return obj;
                }
                ,
                formatResponseForDashboard(dataToFormat) {
                    let dict_response = dataToFormat;
                    let dict_accepted = dict_response['connectionreport'];
                    let dict_withdraw = dict_response['statisticwithdraw'];
                    let dict_metrics = dict_response['user-metrics'];
                    let linkedin_posts = dict_response['linkedin-liked-posts'];
                    let dict_configuration_limit = dict_response['count_active_configuration'];
                    this.statsSumActionsLinkedin = dict_response['SumActionsLinkedIn'];
                    this.statsDiffActionsLinkedin = dict_response['DiffActionsLinkedIn'];
                    localStorage.ReusableTemplates = JSON.stringify(dict_response['ReusableTemplates']);
                    localStorage.ReusableSchedules = JSON.stringify(dict_response['ReusableSchedules']);
                    if ('crm_tokens' in dict_response) {
                        console.log('dict_response crm token', dict_response['crm_tokens'])
                        localStorage.CrmToken = JSON.stringify(dict_response['crm_tokens']);
                    }
                    this.$store.commit('setDictConfigurationLimit', dict_configuration_limit);
                    for (let key in linkedin_posts) {
                        this.lineLikedPosts.chartData.labels.push(linkedin_posts[key]['user']);
                        // let str = linkedin_posts[key]
                        this.lineLikedPosts.chartData.datasets[0].data.push(linkedin_posts[key]['number_connections'])
                    }
                    if (this.lineLikedPosts.chartData.labels.length > 0) {
                        this.linkednLikedPostsState = true
                    }
                    if (!('empty' in dict_metrics)) {
                        let ct = 0;
                        for (let keyMetricsLocation in dict_metrics['location_distribution']) {
                            this.pieOptionsMetricsLocation.chartData.labels.push(keyMetricsLocation);
                            this.pieOptionsMetricsLocation.chartData.datasets[0].data.push(dict_metrics['location_distribution'][keyMetricsLocation]);
                            this.pieOptionsMetricsLocation.chartData.datasets[0].backgroundColor.push(this.colorsForPie[ct]);
                            ct++;
                        }
                        ct = 0;
                        for (let keyMetricsDistribution in dict_metrics['industry_distribution']) {
                            this.pieOptionsMetricsIndustry.chartData.labels.push(keyMetricsDistribution);
                            this.pieOptionsMetricsIndustry.chartData.datasets[0].data.push(dict_metrics['industry_distribution'][keyMetricsDistribution]);
                            this.pieOptionsMetricsIndustry.chartData.datasets[0].backgroundColor.push(this.colorsForPie[ct]);
                            ct++;
                        }


                        this.metricsUser = true
                    }

                    for (let key in dict_accepted) {
                        var str = dict_accepted[key];
                        var _array = str.split("_");
                        var accepted = _array[0];
                        var acceptedMsg1 = _array[1];
                        var acceptedMsg2 = _array[2];
                        var sent = _array[3];
                        var ysySearchName = _array[4];
                        var ratio =  Math.floor((accepted/sent)*100)+'%'
                        this.barChartAcceptedUsers.chartData.labels.push(ysySearchName+"\n Accept ratio :" + ratio);
                        this.barChartAcceptedUsers.chartData.datasets[0].data.push(accepted);
                        this.barChartAcceptedUsers.chartData.datasets[1].data.push(acceptedMsg1);
                        this.barChartAcceptedUsers.chartData.datasets[2].data.push(acceptedMsg2);
                        this.barChartAcceptedUsers.chartData.datasets[3].data.push(sent)
                    }

                    if ('empty' in dict_withdraw) {
                        this.statisticConnection = false
                    } else {
                        for (let key in dict_withdraw) {
                            if (!key.includes("refresh Time") && !key.includes("pending_count")) {
                                if (parseInt(dict_withdraw[key]) > 10) {
                                    this.barChartPendingRequest.chartData.labels.push(key)
                                    let str = dict_withdraw[key]
                                    this.barChartPendingRequest.chartData.datasets[0].data.push(str)
                                }
                            }
                        }
                        this.refreshTimerWithdraw = dict_withdraw['refresh Time'];
                        this.statisticConnection = true

                    }

                    this.$store.commit('setDurationToWithdraw', this.barChartPendingRequest.chartData.labels);
                    this.loading = false;
                    this.isSplashloading = false;
                }
                ,
                refreshIdToken,
                initDashboardUser() {
                    const path = `${this.BACKEND_YSY}/linkedin/generate-dashboard-user`;
                    const headers = {
                        'Content-type': 'application/json',
                        'Authorization': `Bearer ${localStorage.id_token}`
                    };
                    this.$http
                        .post(path, {
                            username: this.$store.getters.getUser,
                            email_linkedin: this.$store.getters.getEmailLinkedin
                        }, {headers})
                        .then(res => {
                                this.formatResponseForDashboard(res.data);
                                localStorage.dict_response_dashboard = JSON.stringify(res.data);
                            }
                        ).catch(error => {
                        console.log(error)
                    });
                    console.log('End of Successful Run')
                },

            }
        ,
        mounted() {
            if (localStorage.dict_response_dashboard) {
                this.loading = false;
                this.isSplashloading = false;
                console.log('Trying to get the data from localStorage', JSON.parse(localStorage.dict_response_dashboard));
                this.formatResponseForDashboard(JSON.parse(localStorage.dict_response_dashboard))
            }
        }
        ,
        created() {
            if (!localStorage.dict_response_dashboard) {
                console.log('loading the data in local store')
                this.isSplashloading = true;
                this.initDashboardUser();
            } else {
                console.log('No need for axios - Data in local store')
            }
        }

    }
</script>

